import { render } from "./SpmPanelMenu.vue?vue&type=template&id=3f3a45be"
import script from "./SpmPanelMenu.vue?vue&type=script&lang=ts"
export * from "./SpmPanelMenu.vue?vue&type=script&lang=ts"

import "./SpmPanelMenu.vue?vue&type=style&index=0&id=3f3a45be&lang=scss"
script.render = render

export default script